import { render, staticRenderFns } from "./6ListManagement.vue?vue&type=template&id=bbf96e6e&scoped=true&"
import script from "./6ListManagement.vue?vue&type=script&lang=js&"
export * from "./6ListManagement.vue?vue&type=script&lang=js&"
import style0 from "./6ListManagement.vue?vue&type=style&index=0&id=bbf96e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf96e6e",
  null
  
)

export default component.exports